export class SubCategory {
    constructor(
        public id: any,
        public parent_category_id: any,
        public color: string,
        public title: string,
        public description: string,
        public need_pro: boolean,
        public is_available: boolean,
        public activate_users: string[],
    ) { }
}
